import { createCustomAction } from 'typesafe-actions';
import { VIEWITEM_FILTER_EXPRESSIONS_GENERATED } from './constants';
import { ViewItemFilterExpressionsGeneratedType } from './ViewItemFilterExpressionsGeneratedType';

export const viewItemFilterExpressionsGenerated = createCustomAction(VIEWITEM_FILTER_EXPRESSIONS_GENERATED, (type) => {
    return (payload: ViewItemFilterExpressionsGeneratedType) => ({ type, payload });
});
